import base from "./base.service";


const authorizedInstance = base.service(true);
const unauthorizedInstance = base.service(false);

export const getAllBookings = (pageSize, pageNumber, status, date, createdDate, searchString) => {
    let query = `/Booking/get-all?PageSize=${pageSize}&PageNumber=${pageNumber}&status=${status}`;
    
    if (date) {
        query += `&reservationDate=${encodeURIComponent(date)}`;
    }

    if (createdDate) {
        query += `&createdDate=${encodeURIComponent(createdDate)}`;
    }

    if (searchString) {
        query += `&searchString=${encodeURIComponent(searchString)}`;
    }
    
    return authorizedInstance.get(query);
};

export const confirmReservation = (id) => {
    return authorizedInstance.get(`/Booking/confirm-reservation/${id}`);
};

export const rejectReservation = (id) => {
    return authorizedInstance.get(`/Booking/reject-reservation/${id}`);
};

export const getById = (id) => {
    return authorizedInstance.get(`/Booking/by-id/${id}`);
};

export const updateBooking = (updateBookingRequest, id) => {
    return authorizedInstance.post(`/Booking/update/${id}`, updateBookingRequest);
}

export const getFreeReservations = (playroomId, date) => {
    return unauthorizedInstance.get(`/Booking/get-free-reservations?playroomId=${playroomId}&date=${date}`);
}


export const createNewBooking = (bookingRequest) => {
    return unauthorizedInstance.post("/Booking/create-new", bookingRequest);
}
 
export const getBusyDates = (playroomId) => {
    return unauthorizedInstance.get(`/Booking/get-busy-dates/${playroomId}`);
}

export const rejectReservationByClient = (reservationCode) => {
    return unauthorizedInstance.get(`/Booking/client-rejection/${reservationCode}`);
}


export default {
    getAllBookings,
    confirmReservation,
    rejectReservation,
    getById,
    updateBooking,
    getFreeReservations,
    createNewBooking,
    getBusyDates,
    rejectReservationByClient
};